// Small colored pill for menu_imports.status. Reused on the table row and
// the detail page.

import type { MenuImportStatus } from '@/api/admin';
import { formatStatus } from '@/lib/format';

const CLASSES: Record<MenuImportStatus, string> = {
  draft: 'bg-amber-100 text-amber-900 ring-amber-200',
  approved: 'bg-emerald-100 text-emerald-900 ring-emerald-200',
  rejected: 'bg-slate-100 text-slate-700 ring-slate-200',
  failed: 'bg-rose-100 text-rose-900 ring-rose-200',
};

export function StatusBadge({ status }: { status: MenuImportStatus }) {
  return (
    <span
      className={
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ' +
        CLASSES[status]
      }
    >
      {formatStatus(status)}
    </span>
  );
}
